module.exports = __webpack_public_path__ + "images/logo-env_production_collapsed.svg?1bf10dbc1b8c69e614721c348ffbb2d0";